// material-ui
import orderkeyIcon from 'assets/images/logos/orderkey-hub.png';
import CjLogoIcon from 'assets/images/logos/cj_logo.svg'
import { useSelector } from 'react-redux';

// ==============================|| LOGO SVG ||============================== //

const LogoMain = () => {

  const flavour = useSelector((state) => state.auth.flavour)
  const isExternal = flavour && flavour.isExternal;
  return <img src={isExternal ? CjLogoIcon : orderkeyIcon} alt='Order-key Hub' width={200} height={'auto'} />;
};

export default LogoMain;
